import {EnvironmentProviders, Provider} from '@angular/core';
import {createFeature, FeatureConfig, provideState} from '@ngrx/store';
import {activityFeatureName, activityReducer, ActivityState} from './store/activity.reducers';
import {provideEffects} from '@ngrx/effects';
import {ActivityEffects} from './store/activity.effects';
import {ActivityFacade} from './store/activity.facade';
import {ActivityRepository} from './store/activity.repository';
import {ActivityRestService} from './api/activity-rest.service';

export function provideActivity(): (EnvironmentProviders | Provider)[] {
    return [
        provideState(createFeature({
            name: activityFeatureName,
            reducer: activityReducer
        } as FeatureConfig<string, ActivityState>)),
        provideEffects([ActivityEffects]),
        ActivityFacade, ActivityRepository, ActivityRestService
    ];

}

